import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap, catchError, map } from 'rxjs/operators';
import { ModalService } from './modal.service';
import { HttpToken } from './http-function-token-class';
import { IOption } from './http-function-token';

var extend_default = {
  onlyData: false,
  errMsg: null,
}

/**
 * 使用的时候必须注入
 * public modal: ModalService
 * public http: HttpClient
 */

/**
 * 抛错
 * @param res 接口数据 
 * @param target this绑定
 * @param code 接口返回的code码，默认是'1000000'
 */
export function ThrowError(res: any, config: IOption, target?: any) {
  if (
    res !== null &&
    res[config.code] !== undefined &&
    res[config.code] !== config.codeValue &&
    res.message !== undefined
  ) {
    throw res;
  }
  if (res === null) {
    throw {
      msg: '数据异常'
    };
  }
}

/**
 * 错误信息
 * @param err 
 */
export function errorMessage(err: any): any {
  return err.message || (err.error && err.error.message) || null;
}

/**
 * get
 * 返回数据包括 code message data
 * @param url 接口地址
 * @param extend onlyData: 是否只获取data部分 errMsg: 错误信息
 */

export function GET(url: string, extend: any = {}) {
  return function (target: any, key: string, descriptor: PropertyDescriptor) {
    descriptor.value = function (params?: HttpParams): Observable<any> {
      var _extend = Object.assign({}, extend_default, extend);
      return this.http.get(url, params).pipe(
        tap((result: any) => ThrowError(result, HttpToken.config, this)),
        map((res: any) => {
          return _extend.onlyData ? res[HttpToken.config.data] : res;
        }),
        catchError((err) => {
          if (this.modal && _extend.errMsg) {
            (<ModalService>this.modal).alert(_extend.errMsg, 'error', errorMessage(err));
          }
          throw err;
        })
      );
    };
  };
}

/**
 * post
 * @param url 接口地址
 * @param extend onlyData: 是否只获取data部分 errMsg: 错误信息
 */
export function POST(url: string, extend: any = {}): Function {
  return function (target: any, key: string, descriptor: PropertyDescriptor): void {
    descriptor.value = function (body, params?: HttpParams): Observable<any> {
      var _extend = Object.assign({}, extend_default, extend);
      return this.http.post(url, body, params).pipe(
        tap((result: any) => ThrowError(result, HttpToken.config, this)),
        map((res: any) => {
          return _extend.onlyData ? res[HttpToken.config.data] : res;
        }),
        catchError((err) => {
          if (this.modal && _extend.errMsg) {
            (<ModalService>this.modal).alert(_extend.errMsg, 'error', errorMessage(err));
          }
          throw err;
        })
      );
    };
  };
}

/**
 * delete
 * @param url 接口地址
 * @param extend onlyData: 是否只获取data部分 errMsg: 错误信息
 */
export function DELETE(url: string, extend: any = {}): Function {
  return function (target: any, key: string, descriptor: PropertyDescriptor) {
    descriptor.value = function (params?: HttpParams): Observable<any> {
      var _extend = Object.assign({}, extend_default, extend);
      return this.http.delete(url, params).pipe(
        tap((result: any) => ThrowError(result, HttpToken.config, this)),
        map((res: any) => {
          return _extend.onlyData ? res[HttpToken.config.data] : res;
        }),
        catchError((err) => {
          if (this.modal && _extend.errMsg) {
            (<ModalService>this.modal).alert(_extend.errMsg, 'error', errorMessage(err));
          }
          throw err;
        })
      );
    };
  };
}

/**
 * patch
 * @param url 接口地址
 * @param extend onlyData: 是否只获取data部分 errMsg: 错误信息
 */
export function PATCH(url: string, extend: any = {}): Function {
  return function (target: any, key: string, descriptor: PropertyDescriptor) {
    descriptor.value = function (params?: HttpParams): Observable<any> {
      var _extend = Object.assign({}, extend_default, extend);
      return this.http.patch(url, null, params).pipe(
        tap((result: any) => ThrowError(result, HttpToken.config, this)),
        map((res: any) => {
          return _extend.onlyData ? res[HttpToken.config.data] : res;
        }),
        catchError((err) => {
          if (this.modal && _extend.errMsg) {
            (<ModalService>this.modal).alert(_extend.errMsg, 'error', errorMessage(err));
          }
          throw err;
        })
      );
    };
  };
}

/**
 * patch-data
 * @param url 接口地址
 * @param extend onlyData: 是否只获取data部分 errMsg: 错误信息
 */
export function PUT(url: string, extend: any = {}): Function {
  return function (target: any, key: string, descriptor: PropertyDescriptor) {
    descriptor.value = function (body, params?: HttpParams): Observable<any> {
      var _extend = Object.assign({}, extend_default, extend);
      return this.http.put(url, body, params).pipe(
        tap((result: any) => ThrowError(result, HttpToken.config, this)),
        map((res: any) => {
          return _extend.onlyData ? res[HttpToken.config.data] : res;
        }),
        catchError((err) => {
          if (this.modal && _extend.errMsg) {
            (<ModalService>this.modal).alert(_extend.errMsg, 'error', errorMessage(err));
          }
          throw err;
        })
      );
    };
  };
}
